/*
  Shop Pay address notice (snippets/rgg-wallet-confirm.liquid).
  Loaded site-wide from snippets/scripts.liquid, not inline in the snippet: the cart
  drawer is re-rendered with innerHTML when an item is added, and inline scripts in
  re-rendered HTML never run. On a page that loaded with an empty cart the element
  was never defined, so the drawer notice stayed hidden.
*/
(function () {
  if (customElements.get('rgg-wallet-confirm')) return;
  var SHOP_PAY = 'shop-pay-wallet-button';

  class RggWalletConfirm extends HTMLElement {
    connectedCallback() {
      this.note = this.querySelector('[data-rgg-wallet-note]');
      this.buttons = this.querySelector('[data-rgg-wallet-buttons]');
      if (!this.note || !this.buttons) return;
      // Shopify renders the wallet buttons async, so re-check when they appear.
      this.observer = new MutationObserver(() => this.sync());
      this.observer.observe(this.buttons, { childList: true, subtree: true });
      this.sync();
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    sync() {
      var hasShopPay = !!this.querySelector(SHOP_PAY);
      if (this.note.hidden === hasShopPay) this.note.hidden = !hasShopPay;
    }
  }

  customElements.define('rgg-wallet-confirm', RggWalletConfirm);
})();
